import React from 'react';


type FavoriteStarButtonProps = {
    checked: any;
    size: string;
}

const LogoFavorite = (props: FavoriteStarButtonProps) => {

    const color = props.checked ? '#ffdb4d' : 'none';
    const strokeColor = props.checked ? '#ffdb4d' : '#828282';

    return (
        <div style={{color:color, display:'flex', alignItems:'center'}}>
            <svg width={props.size} height={props.size} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
                <g fill="none" fillRule="evenodd">
                    <path d="M29.349 11.294l-8.383-.61-3.197-7.826a1.759 1.759 0 00-1.644-1.111c-.667 0-1.34.372-1.644 1.11l-3.197 7.826-8.383.61c-1.552.086-2.244 2.089-1.037 3.132l6.485 5.39-1.99 8.174c-.334 1.203.613 2.204 1.662 2.204.315 0 .637-.092.934-.287l7.085-4.438 7.176 4.438c.297.201.619.287.922.287 1.025 0 1.935-1.001 1.668-2.204l-1.99-8.173 6.57-5.39c1.207-1.044.515-3.047-1.037-3.132"
                        fill={color}
                        stroke={strokeColor}
                        strokeWidth={2}/>
                </g>
            </svg>
        </div>
    );
};

export default LogoFavorite;